import { useUser } from '@clerk/nextjs';
import {
  type PatientScheduleDayResult,
  UNCHECKED_PATIENT_SCHEDULE,
} from '@web-app/utils/scheduling/patient-schedule-day';
import { trpc } from '@web-app/utils/trpc';

export function usePatientScheduleConflicts({
  patientId,
  date,
  appointmentTypeId,
  timezone,
  excludeAppointmentId,
  enabled = true,
}: {
  patientId: string | null;
  date: string | null;
  appointmentTypeId: string | null;
  timezone: string | null;
  excludeAppointmentId?: string;
  enabled?: boolean;
}): PatientScheduleDayResult {
  const { user, isLoaded } = useUser();
  const query = trpc.scheduling.patientScheduleConflictsForDay.useQuery(
    {
      patientId: patientId ?? '',
      date: date ?? '',
      appointmentTypeId: appointmentTypeId ?? '',
      timezone: timezone ?? '',
      excludeAppointmentId,
      viewerId: user?.id ?? '',
    },
    {
      enabled:
        enabled &&
        isLoaded &&
        !!user?.id &&
        !!patientId &&
        !!date &&
        !!appointmentTypeId &&
        !!timezone,
      staleTime: 2 * 60_000,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
  return query.isError || !query.data ? UNCHECKED_PATIENT_SCHEDULE : query.data;
}
